/**
 * Jesus feeds 5000 coloring pages — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_bible_stories`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const jesusFeeds5000ColoringPagesPack: ToilePack = {
    slug: 'jesus-feeds-5000-coloring-pages',
    category: 'faith',
    name: 'Jesus feeds 5000 coloring pages',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'lunch', label: "Boy's lunch", subject: 'a boy offering his basket of five loaves and two fish to a disciple, the crowd sitting on the grass behind'},
        {key: 'blessing', label: 'The blessing', subject: 'Jesus looking up to heaven and giving thanks as he breaks the bread, the loaves and fish before him'},
        {key: 'baskets', label: 'Twelve baskets', subject: 'the disciples gathering the leftover pieces into twelve full baskets on the hillside'},
    ],
    styles: [
        {key: 'bold', label: 'Bold and simple', style: 'bold thick-outline coloring book style, one heavy uniform black line, big simple open shapes for young children', palette: 'black ink only', framing: 'The drawing centered with a wide white margin on all sides'},
        {key: 'classic', label: 'Classic', style: 'classic coloring book line art, medium uniform black line, moderate detail and open shapes for ages six to nine', palette: 'black ink only', framing: 'The full page used, the drawing centered with a white margin'},
        {key: 'detailed', label: 'Fine detail', style: 'fine-line detailed coloring page, thin uniform black line, patterned robes, leaves and waves for older children', palette: 'black ink only', framing: 'The scene held inside a plain thin rectangular border with a white margin outside it'},
    ],
    directions: ['more baskets', 'jesus teaching', 'lakeside'],
    directionHint: 'try: more baskets',
    seo: {
        title: 'Jesus Feeds 5000 Coloring Pages: Lunch, Blessing, Baskets',
        metaDescription: "Nine coloring pages of Jesus feeding the five thousand from John 6: the boy's lunch, the blessing and the twelve baskets, in three styles.",
        h1: "Jesus feeds 5000 coloring pages: the boy's lunch, the blessing, twelve baskets",
        tagline: 'Nine pages of the feeding of the five thousand in three scenes, each in three line weights.',
        intro: 'Printable coloring pages of the feeding of the five thousand for Sunday school and Christian homeschool, the miracle told in John 6. Three scenes: a boy offering five loaves and two fish, Jesus giving thanks and breaking the bread, and the disciples gathering twelve baskets of leftovers. Bold, classic and fine-detail lines. Type a different scene, and the same styles carry it.',
        useCases: [
            'a Sunday school lesson on John 6',
            "a children's church craft table",
            'a Christian homeschool Gospel unit',
            'a bulletin board on sharing what we have',
        ],
        faq: [
            {q: 'Which part of the story do these show?', a: "The boy's lunch, the blessing of the bread, and the twelve baskets."},
            {q: 'Does the crowd appear?', a: 'Yes. The crowd sits on the grass in the first scene.'},
            {q: 'Can I ask for Jesus teaching the crowd?', a: 'Yes. Type the scene you want. The request shapes the page, but a result is not promised to match it exactly.'},
            {q: 'Are the pages in color?', a: 'No. Each page is black line on white, with open shapes to color in.'},
        ],
    },
}
